import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLang } from '../context/LangContext';
import { useBackgroundJobs } from '../context/BackgroundJobsContext';
import { APP_VERSION } from '../App';

const NAV = [
  { to: '/',           icon: 'bi-grid-1x2',           key: 'nav_dashboard' },
  { to: '/audits',     icon: 'bi-clipboard2-check',   key: 'nav_audits' },
  { to: '/clients',    icon: 'bi-building',            key: 'nav_clients' },
  { to: '/frameworks', icon: 'bi-diagram-3',           key: 'nav_frameworks' },
  { to: '/templates',  icon: 'bi-file-earmark-word',  key: 'nav_templates' },
  { to: '/reports',    icon: 'bi-file-earmark-bar-graph', key: 'nav_reports' },
];
const ADMIN_NAV = [
  { to: '/mail',  icon: 'bi-envelope', key: 'nav_mail' },
  { to: '/users', icon: 'bi-people', key: 'nav_users' },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const { t, lang, switchLang } = useLang();
  const { runningCount } = useBackgroundJobs();
  const navigate = useNavigate();

  function handleLogout() { logout(); navigate('/login'); }

  return (
    <div className="d-flex">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <img
            src="/logo-fdconsult.png"
            alt="FDConsult"
            style={{ width: 130, display: 'block', background: '#fff', borderRadius: 6, padding: '5px 8px' }}
          />
          <span style={{ fontSize: 11, opacity: 0.6, marginTop: 4, display: 'block' }}>Audit Tool</span>
        </div>

        <nav className="nav flex-column pt-2">
          {NAV.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
            >
              <i className={`bi ${item.icon}`} />
              {t(item.key)}
            </NavLink>
          ))}
          <NavLink
            to="/background-jobs"
            className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
          >
            <i className="bi bi-list-task" />
            {t('nav_background_jobs')}
            {runningCount > 0 && (
              <span className="spinner-border spinner-border-sm ms-2" style={{ width: 12, height: 12 }} />
            )}
          </NavLink>
          {user?.role === 'admin' && ADMIN_NAV.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
            >
              <i className={`bi ${item.icon}`} />
              {t(item.key)}
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <NavLink to="/account" className="user-name d-block text-decoration-none" title={t('account_title')}>
            <i className="bi bi-person-circle me-1" />{user?.name}
          </NavLink>
          <div style={{ fontSize: 11 }}>{user?.role}</div>
          <div className="lang-toggle">
            <button className={lang === 'nl' ? 'active' : ''} onClick={() => switchLang('nl')}>NL</button>
            <button className={lang === 'en' ? 'active' : ''} onClick={() => switchLang('en')}>EN</button>
          </div>
          <button
            onClick={handleLogout}
            className="btn btn-link p-0 mt-2"
            style={{ fontSize: 12, color: '#64748b' }}
          >
            <i className="bi bi-box-arrow-left me-1" />
            {t('nav_logout')}
          </button>
          <div style={{ fontSize: 10, color: '#475569', marginTop: 8 }}>v{APP_VERSION}</div>
        </div>
      </aside>

      <main className="main-content flex-grow-1">
        {children}
      </main>
    </div>
  );
}
